import {ProcessFlowchartNodeType} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

import {ProcessFlowchartEditorConfigurator, WorkflowFeature} from './ProcessFlowchartEditorConfigurator';

export function getAllowedNodeTypes(
  configurator: ProcessFlowchartEditorConfigurator<unknown>
): Array<ProcessFlowchartNodeType> {
  return [
    ...(configurator.enabledWorkflowsFeatures().includes(WorkflowFeature.ENABLE_LOGIC_NODES)
      ? [ProcessFlowchartNodeType.ROUTER_NODE, ProcessFlowchartNodeType.STOP_NODE]
      : []),
    ProcessFlowchartNodeType.TASK_SCHEMA_NODE,
  ];
}
